export const UPDATE_LOCATIONS = "UPDATE_LOCATIONS";
export const GET_ALL_LOCATIONS = "GET_ALL_LOCATIONS";
export const SET_LOCATION_LOADING = "SET_LOCATION_LOADING";
